import { render, staticRenderFns } from "./ZastosowanieSheet.vue?vue&type=template&id=386ff170&"
import script from "./ZastosowanieSheet.vue?vue&type=script&lang=ts&"
export * from "./ZastosowanieSheet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports